/* eslint-disable no-new-object */
import axios from "axios";
import $ from "jquery";

export function getWindowSize() {
  const { innerWidth, innerHeight } = window;
  return { innerWidth, innerHeight };
}
export function isNull(sopt) {
  if (sopt === undefined || sopt === null || sopt === "" || sopt === "null")
    return true;
  return false;
}
//값이 없으면
export const IfNotNull = (input) => {
  if (input !== null && input !== undefined && input !== "") {
    return true;
  }
  return false;
};
//객체가 비어 있는지 확인
export function isObjEmpty(obj) {
  for (var prop in obj) {
    if (obj.hasOwnProperty(prop)) return false;
  }
  return true;
}
/* 객체가 비어 있는지 확인 */
export function isEmptyString(sString) {
  if (sString === undefined || sString === null || sString === "") return false;
  else return true;
}
export function isEmptyObj(obj) {
  if (obj.constructor === Object && Object.keys(obj).length === 0) {
    return true;
  }
  return false;
}
export function replaceAll(string, search, replace) {
  if (isNull(string)) return "";
  //console.log(string,search,replace);

  if (string instanceof Date) {
    const year = string.getFullYear();
    const month = (string.getMonth() + 1).toString().padStart(2, "0");
    const day = string.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  return string.split(search).join(replace);
}
//시간표시
export function GetTimes(stime) {
  if (stime === undefined || stime === null || stime === "") return "";
  return stime.substr(0, 5);
}

//날짜 문자-->DATE
export function ChangeToDateFormat(sdate) {
  if (isNull(sdate)) return null;
  else return new Date(sdate);
}
//날짜 문자 : yyymmdd --> yyyy-mm-dd
export function ChangeDateStringFormat(sdate) {
  const yy = sdate.substr(0, 4);
  const mm = sdate.substr(4, 2);
  const dd = sdate.substr(6, 2);
  return yy + "-" + mm + "-" + dd;
}
//날짜 문자점검
export function CheckDateFormat(sdate) {
  const yy = sdate.substr(0, 4);
  const mm = sdate.substr(4, 2);
  const dd = sdate.substr(6, 2);
  const retArray = { value: true, message: "" };
  if (Number(mm) > 12) {
    retArray.value = false;
    retArray.message = "월은 01~12입니다.";
    return retArray;
  }
  const lastDate = new Date(yy, mm, 0);
  const lastDays = lastDate.getDate();
  if (Number(dd) > Number(lastDays)) {
    retArray.value = false;
    retArray.message = `입력한 월의 일자는 01~${lastDays}입니다.`;
    return retArray;
  }
  return retArray;
}

export function GetCurrentMonth() {
  const today = new Date();
  let year = today?.getFullYear();
  let month = ("0" + (today?.getMonth() + 1)).slice(-2);
  return year + "-" + month;
}
export function ChangeShowMonth(smonth, ino) {
  let sdate = new Date(smonth + "-01");
  sdate.setMonth(sdate.getMonth() + ino);
  let year = sdate?.getFullYear();
  let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
  return year + "-" + month;
}
export function ChangeSearchingDateFormat(sdate, sdiv) {
  let ndate = "";
  //console.log(sdate);
  if (sdate === undefined || sdate === "" || sdate === null) {
    ndate = null;
  } else {
    let year = sdate?.getFullYear();
    let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
    let day = ("0" + sdate?.getDate()).slice(-2);
    ndate = year + sdiv + month + sdiv + day;
  }
  return ndate;
}
export function ChangeChattingDate(sdbdate) {
  let sdate = null;
  if (sdbdate === undefined || sdbdate === null || sdbdate === "")
    sdate = new Date();
  else {
    if (sdbdate.indexOf(" ") > 0) {
      sdbdate = sdbdate.replace(" ", "T");
    }
    sdate = new Date(sdbdate);
  }

  let year = sdate.getFullYear();
  let month = ("0" + (sdate.getMonth() + 1)).slice(-2);
  let day = ("0" + sdate.getDate()).slice(-2);

  let hours = ("0" + sdate.getHours()).slice(-2);
  let minutes = ("0" + sdate.getMinutes()).slice(-2);
  let seconds = ("0" + sdate.getSeconds()).slice(-2);

  const ndate =
    year +
    "." +
    month +
    "." +
    day +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds;
  return ndate;
}
export function ChangeDateFormat(sdate) {
  if (sdate === "") sdate = new Date();
  let year = sdate?.getFullYear();
  let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
  let day = ("0" + sdate?.getDate()).slice(-2);
  const ndate = year + "-" + month + "-" + day;
  return ndate;
}
export function exceptTimeFromDate(sdate) {
  if (sdate === null || sdate === "") return "";
  return sdate.substr(0, 10);
}
export function ChangeDateFormatToKorean(sdate) {
  if (sdate === "") sdate = new Date();
  let year = sdate.getFullYear();
  let month = sdate.getMonth() + 1;
  let day = sdate.getDate();
  const ndate = year + "년 " + month + " 월" + day + " 일";
  return ndate;
}
export function ChangeDateTimeFormat(odate) {
  let sdate = null;
  if (odate === undefined || odate === null || odate === "") sdate = new Date();
  else {
    if (odate.indexOf(" ") > 0) {
      odate = odate.replace(" ", "T");
    }
    sdate = new Date(odate);
  }

  let year = sdate.getFullYear();
  let month = ("0" + (sdate.getMonth() + 1)).slice(-2);
  let day = ("0" + sdate.getDate()).slice(-2);

  let hours = ("0" + sdate.getHours()).slice(-2);
  let minutes = ("0" + sdate.getMinutes()).slice(-2);
  let seconds = ("0" + sdate.getSeconds()).slice(-2);

  const ndate =
    year +
    "-" +
    month +
    "-" +
    day +
    " " +
    hours +
    ":" +
    minutes +
    ":" +
    seconds;
  return ndate;
}
export function ChangeDateMonth(sdate, imode = 0) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    let sdateString = sdate.substr(0, 7);
    if (imode === 1) sdateString = sdateString.replace(/-/g, ".");
    return sdateString;
  }
}
export function ChangeDateString(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    return sdate.replace(/-/g, ".");
  }
}
export function ChangeDateStringByDash(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    return sdate.replace(/./g, "-");
  }
}
export function ChangeDateStringOnlyDate(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    sdate = sdate.substr(0, 10);
    return sdate.replace(/-/g, ".");
  }
}
export function ChangeDateStringToKorean(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    if (sdate.indexOf(" ") > 0) {
      const datetimeArray = sdate.split(" ");
      sdate = datetimeArray[0];
    }
    const dateArray = sdate.split("-");
    const ndate =
      dateArray[0] +
      "년 " +
      Number(dateArray[1]) +
      " 월 " +
      Number(dateArray[2]) +
      " 일";
    return ndate;
  }
}
export function ChangeDateTimeString(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    const dateArray = sdate.split(" ");
    return dateArray[0].replace(/-/g, ".") + " " + dateArray[1];
  }
}

//날짜계산
export function SetDateFromDate(smode, ibetValue) {
  let ndate = new Date();
  if (smode === "y") {
    return new Date(ndate.setFullYear(ndate.getFullYear() + ibetValue));
  } else if (smode === "m") {
    return new Date(ndate.setMonth(ndate.getMonth() + ibetValue));
  } else {
    return new Date(ndate.setDate(ndate.getDate() + ibetValue));
  }
}

export function CheckToday(sObj) {
  const cDate = new Date();

  const sdate = new Date(sObj.emd_rdate);

  const cyear = cDate.getFullYear();
  const cmonth = cDate.getMonth();
  const cday = cDate.getDate();

  const syear = sdate.getFullYear();
  const smonth = sdate.getMonth();
  const sday = sdate.getDate();

  if (cyear === syear && cmonth === smonth && cday === sday) {
    if (
      isNull(sObj.emc_riding_photo1) &&
      isNull(sObj.emc_riding_photo2) &&
      isNull(sObj.emc_riding_photo3) &&
      isNull(sObj.emc_riding_photo4) &&
      isNull(sObj.emc_quit_photo) &&
      isNull(sObj.emc_calc_photo) &&
      sObj.emc_driving === 0
    ) {
      return 0;
    } else {
      return 1;
    }
  } else return -1;
}
export function CheckTodayDriving(chkList) {
  const sdate = new Date();
  let year = sdate?.getFullYear();
  let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
  let day = ("0" + sdate?.getDate()).slice(-2);
  const ndate = year + "-" + month + "-" + day;
  for (var i = 0; i < chkList?.length; i++) {
    if (chkList[i].emd_rdate === ndate) {
      return true;
    }
  }
  return false;
}
export function CheckDriving(emd_rdate) {
  const sdate = new Date();
  let year = sdate?.getFullYear();
  let month = ("0" + (sdate?.getMonth() + 1)).slice(-2);
  let day = ("0" + sdate?.getDate()).slice(-2);
  const ndate = year + "-" + month + "-" + day;

  if (emd_rdate === ndate) {
    return true;
  }
  return false;
}
export function ChoiceDate(sdate1, sdate2) {
  if (sdate1 !== null && sdate2 !== null) {
    //console.log(new Date(sdate1));
    return new Date(sdate1);
  } else if (sdate1 !== null) {
    //console.log(new Date(sdate1));
    return new Date(sdate1);
  } else if (sdate2 !== null) {
    //console.log(new Date(sdate2));
    return new Date(sdate2);
  } else {
    //console.log(new Date());
    return new Date();
  }
}

export function passedDays(sdate) {
  if (sdate === undefined || sdate === null || sdate === "" || sdate === 0)
    return 100;
  if (sdate.indexOf(" ") > 0) {
    var sdate_tmp = sdate.split(" ");
    sdate = sdate_tmp[0];
  }
  const dday = new Date(sdate);
  const today = new Date();
  const gap = today.getTime() - dday.getTime();
  let passeddays = Math.ceil(gap / (1000 * 60 * 60 * 24));
  return passeddays;
}
export function remainDays(expdate) {
  if (
    expdate === undefined ||
    expdate === null ||
    expdate === "" ||
    expdate === 0
  )
    return -1;
  if (expdate.indexOf(" ") > 0) {
    var expdate_temp = expdate.split(" ");
    expdate = expdate_temp[0];
  }
  const dday = new Date(expdate);
  const today = new Date();

  const gap = dday.getTime() - today.getTime();
  let remaindays = Math.ceil(gap / (1000 * 60 * 60 * 24));
  /*   if(remaindays < 0)
    remaindays = -1; */
  return remaindays;
}

//요일
export function GetWeekendDay(sdate) {
  const week = ["일", "월", "화", "수", "목", "금", "토"];
  const dayOfWeek = week[sdate.getDay()];
  return dayOfWeek;
}
//매월 1일
export function FirstDayForMonth(sdate) {
  const firstDay = new Date(sdate.getFullYear(), sdate.getMonth(), 1);
  return firstDay;
}
//매월 마지막 일자
export function LastDayForMonth(sdate) {
  const lastDay = new Date(sdate.getFullYear(), sdate.getMonth() + 1, 0);
  return lastDay;
}
//해당월의 날짜수
export function getDaysInThisMonth(sdate) {
  const mdays = new Date(
    sdate.getFullYear(),
    sdate.getMonth() + 1,
    0
  ).getDate();
  return mdays;
}

//1000단위 실시간 점검
export function realThousandPoint(snum) {
  if (snum === undefined || snum === null || snum === "") return 0;
  let nNum = "";
  if (snum.toString().indexOf(".") > 0) {
    const numArray = snum.toString().split(".");
    nNum = numArray[0].replace(/[^\d]+/g, "") + "." + numArray[1];
  } else {
    nNum = snum.toString().replace(/[^\d]+/g, "");
  }
  const newNum = addThousandPoint(nNum);
  return newNum;
}
//천단위 콤마찍기--
export function addThousandPoint(snum) {
  if (snum === undefined || snum === null || snum === "") return 0;
  let newNum = "";
  if (snum === "-") return snum;
  if (snum.toString().indexOf(".") > 0) {
    const numArray = snum.toString().split(".");
    newNum =
      numArray[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "." + numArray[1];
  } else {
    newNum = parseInt(snum)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return newNum;
}
//천단위 콤마지우기
export function removeThousandPoint(snum) {
  let newNum = "";
  if (snum.toString().indexOf(".") > 0) {
    const numArray = snum.toString().split(".");
    newNum = numArray[0].replace(/[^\d-]+/g, "") + "." + numArray[1];
  } else {
    newNum = snum.toString().replace(/[^\d-]+/g, "");
  }
  return newNum;
}
//전화번호에 - 넣기
export function ChangeMobileFormat(mbNumber) {
  if (mbNumber === undefined || mbNumber === "" || mbNumber === null) return "";
  //if(mbNumber.length === 8 && onlyNumber(mbNumber)) return mbNumber.substr(0,4)+'-'+mbNumber.substr(4,4);
  //return mbNumber.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, "$1-$2-$3");
  return mbNumber
    .replace(/[^0-9]/g, "")
    .replace(/(^02|^0504|^0505|^0\d{2})(\d+)?(\d{4})$/, "$1-$2-$3");
}
export function ChangeMobileNumber(mbNumber) {
  if (mbNumber === undefined || mbNumber === "" || mbNumber === null) return "";
  if (typeof mbNumber === "number") mbNumber = mbNumber.toString();
  return mbNumber.replace(/[^0-9]/g, "");
}
export function RemakeAddress(saddr, iword) {
  if (saddr === undefined || saddr === "" || saddr === null) return "";
  const addrArray = saddr.split(" ");
  let saddress = addrArray[0];
  if (iword >= 2) {
    if (!isNull(addrArray[1])) saddress += " " + addrArray[1];
  }
  if (iword === 3) {
    if (!isNull(addrArray[2])) saddress += " " + addrArray[2];
  }
  return saddress;
}

//아이디 문자열 점검
//2022-08-17 고객사 요청으로 숫자조합 제거 - KSR
export function checkIDString(asValue) {
  //var regExp = /^(?=.*\d)(?=.*[a-zA-Z])[0-9a-zA-Z]{6,25}$/; //  6자 이상 영문 + 숫자 조합
  var regExp = /^[a-z|A-Z|0-9|]{6,25}$/; //영문,숫자 6자 이상
  if (!regExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//2022-08-17 고객사 요청으로 닉네임은 한글도 포함 - KSR 추가
export function checkNickString(asValue) {
  var regExp = /^[ㄱ-ㅎ|가-힣|a-z|A-Z|0-9|]{3,25}$/; //영문,한글,숫자 6자 이상
  if (!regExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}
//한글제외
export function isExceptKoreanString(asValue) {
  if (asValue === undefined || asValue === null || asValue === "") return "";
  var regex = /[^0-9a-zA-Z]/g;
  var returnString = asValue.replace(regex, "");
  return returnString;
}
//숫자만 입력
export function isOnlyNumber(asValue) {
  if (asValue === undefined || asValue === null || asValue === "") return "";
  var regex = /[^0-9]/g;
  var returnString = asValue.replace(regex, "");
  return returnString;
}

//전화번호 검색
export function isPhone(asValue) {
  var regExp = /^01(?:0|1|[6-9])-(?:\d{3}|\d{4})-\d{4}$/;
  var regExp2 = /^01(?:0|1|[6-9])(?:\d{3}|\d{4})\d{4}$/;
  if (regExp.test(asValue)) {
    return regExp.test(asValue);
  } else if (regExp2.test(asValue)) {
    return regExp2.test(asValue);
  }
}
//이메일 문자열 점검
export function checkEmailString(eString) {
  if (eString === undefined || eString === null || eString === "") return false;
  var regExp =
    /^[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_.]?[0-9a-zA-Z])*.[a-zA-Z]{2,3}$/i;
  if (eString.match(regExp) != null) return true;
  else return false;
}
//비밀번호 형식 검사
export function isPassword(asValue) {
  var regExp = /^(?=.*[a-zA-Z])(?=.*[!@#$%^*+=-])(?=.*[0-9]).{8,16}$/; //  8 ~ 16자 영문, 숫자, 특수문자 조합
  if (!regExp.test(asValue)) {
    return false;
  }
  return regExp.test(asValue); // 형식에 맞는 경우 true 리턴
}
//숫자 체크 정규식
export function onlyNumber(str) {
  return str.replace(/[^0-9.]/g, "").replace(/(\.*)\./g, "$1");
}
//숫자 체크 정규식
export function onlyBankAccountNumber(str) {
  return str.replace(/[^0-9-]/g, "").replace(/(\.*)\./g, "$1");
}
//사업자등록번호
export function checkCorporateRegiNumber(number) {
  number = number.replace(/\s/gi, "");
  var numberMap = number
    .replace(/-/gi, "")
    .split("")
    .map(function (d) {
      return parseInt(d, 10);
    });
  console.log("numberMap");
  console.log(numberMap);

  if (numberMap.length === 10) {
    var keyArr = [1, 3, 7, 1, 3, 7, 1, 3, 5];
    var chk = 0;

    keyArr.forEach(function (d, i) {
      chk += d * numberMap[i];
    });

    chk += parseInt((keyArr[8] * numberMap[8]) / 10, 10);
    console.log(chk);
    return Math.floor(numberMap[9]) === (10 - (chk % 10)) % 10;
  }

  return false;
}

//사업자등록번호
export function isTax(asValue) {
  //var regExp = /^(?=.*[-])(?=.*[0-9]).{8,16}$/;
  var regExp = /^(\d{3,3})+[-]+(\d{2,2})+[-]+(\d{5,5})$/;

  regExp.test("asValue");
  console.log(asValue);
  console.log(regExp.test(asValue));
  if (regExp.test(asValue)) {
    return regExp.test(asValue);
  } else {
    return false;
  }
}

export function resetCareerFromMonths(smonths) {
  if (smonths === undefined || smonths === "" || smonths === null)
    return "없음";
  if (smonths === 0) {
    return "없음";
  } else {
    const years = Math.floor(smonths / 12);
    const months = smonths % 12;
    var sterms = "";
    if (years > 0) {
      sterms = years + " 년";
    }
    if (months > 0) {
      if (sterms !== "") sterms += " ";
      sterms += months + " 개월";
    }
    return sterms;
  }
}
export function CalculateCareerBetweenMonths(edate, sdate) {
  if (sdate === undefined || sdate === "" || sdate === null) {
    sdate = ChangeDateFormat("");
  }
  if (edate === undefined || edate === "" || edate === null) {
    edate = ChangeDateFormat("");
  }

  const expArray1 = sdate.split("-");
  if (expArray1.length === 2) expArray1[2] = "01";
  const startday = new Date(
    Number(expArray1[0]),
    Number(expArray1[1] - 1),
    Number(expArray1[2])
  );
  const expArray2 = edate.split("-");
  if (expArray2.length === 2) expArray2[2] = "01";
  const endday = new Date(
    Number(expArray2[0]),
    Number(expArray2[1] - 1),
    Number(expArray2[2])
  );
  var months;
  months = (endday.getFullYear() - startday.getFullYear()) * 12;
  months -= startday.getMonth();
  months += endday.getMonth();
  if (months < 0) months = 0;
  return Number(months);
}

//주민등록번호 마킹
export function MaskingCivilCode(scode) {
  console.log(scode);
  if (scode === undefined || scode === null || scode === "") {
    return "";
  }
  var ninArray = scode.split("-");
  var retString =
    ninArray[0] + "-" + ninArray[1].replace(/([0-9]{6})$/gi, "******");
  return retString;
}
//이메일 마킹
export function MaskingEmail(scode) {
  if (scode === undefined || scode === null || scode === "") {
    return "";
  }
  var ninArray = scode.split("@");
  const ileng = ninArray[0].length;
  let newString = ninArray[0].substr(0, 3);
  for (var i = 4; i <= ileng; i++) {
    newString += "*";
  }

  var retString = newString + "@" + ninArray[1];
  return retString;
}

//문자열 마킹
export function MaskingString(sString, ist, showString) {
  if (sString === undefined || sString === null || sString === "") {
    return "";
  }
  let newString = "";
  let ileng = sString.length;
  if (ist > 0) {
    newString = sString.substr(0, ist);
  }
  //ileng = ileng - ist;
  for (var i = ist; i < ileng; i++) {
    newString += showString;
  }
  return newString;
}

//첨부파일 확장자 체크
export function checkFileName(str) {
  var ext = str.split(".");
  var ext1 = "." + ext[1].toLowerCase();
  var reg = /(.*?)\.(xlsx|docx|pdf|zip|hwp|ppt)$/;

  if (ext1.match(reg)) {
    return true;
  } else {
    return false;
  }
}

//주문코드생성
export function getPaymentCode() {
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";
  const today = new Date();
  const year = today.getFullYear();
  const month = ("0" + (today.getMonth() + 1)).slice(-2);
  const day = ("0" + today.getDate()).slice(-2);
  let randomstring = "PC" + month + day + year;
  for (let i = 0; i < 6; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}

//코드생성 - 랜덤함수
export function randomString(stringLength) {
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz";

  let randomstring = "";
  for (let i = 0; i < stringLength; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}
//코드생성 - 숫자만 - 랜덤함수
export function randomStringOnlyNumber(stringLength) {
  const chars = "0123456789";

  let randomstring = "";
  for (let i = 0; i < stringLength; i++) {
    const rnum = Math.floor(Math.random() * chars.length);
    randomstring += chars.substring(rnum, rnum + 1);
  }
  return randomstring;
}

export const send_push = async (title, content) => {
  const FCM_KEY =
    "AAAAWg86CJw:APA91bEg9ruDA-NE9K-fm2pPlwKF9Ty84QPIV1EVk8jaAiw8SYdUjdagZtfY21styfbKCifOejgvRYdCqwJWIWVpZWcPkaUa3Srzls29PhUR8sJ-cGmg2gsbU7b2QIOzqOoi6u9LXww-";
  /* const FCM_URL = "https://fcm.googleapis.com/fcm/send"; */
  const FCM_TOPIC = "survey";

  // const token = await axios.get(`${CONFIG.SERVER_HOST_V2}/api/v2/front/getUserToken?user_id=${localStorage.getItem('user_id')}`).then((response) => {
  //   console.log("reviewCount1", response.data[0]);
  //   return  response.data[0].use_count;
  // });
  // const title = await axios.get(`${CONFIG.SERVER_HOST_V2}/api/v2/front/getPushTitle?id=2`).then((response) => {
  //   console.log("reviewCount1", response.data[0]);
  //   return  response.data[0].use_count;
  // });

  // const content = await axios.get(`${CONFIG.SERVER_HOST_V2}/api/v2/front/getPushContent?id=2`).then((response) => {
  //   console.log("reviewCount1", response.data[0]);
  //   return  response.data[0].use_count;
  // });

  /*  var key = ''; */

  // var to =token;
  var to = `/topics/${FCM_TOPIC}`;
  var notification = {
    title: title,
    body: content,
    icon: "아이콘",
    click_action: "url",
    android_channel_id: "survey",
  };

  fetch("https://fcm.googleapis.com/fcm/send", {
    method: "POST",
    headers: {
      Authorization: "key=" + FCM_KEY,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      notification: notification,
      to: to,
    }),
  })
    .then(function (response) {
      console.log("fetch success");
      console.log(response);
      alert("PUSH 발송 되었습니다");
    })
    .catch(function (error) {
      console.error(error);
      alert("fetch error");
    });
};

export function ChangeDate(sdate) {
  if (sdate === null || sdate === undefined || sdate === "") {
    return "";
  } else {
    const dateArray = sdate.split(" ");
    return dateArray[0];
  }
}

export const resetNavMenu = (imenu) => {
  //console.log(imenu);
  let navBlock = document.querySelector(".nav");
  let navItems = navBlock.querySelectorAll(".depth1");
  //console.log(navItems)
  for (var i = 0; i < navItems.length; i++) {
    if (navItems[i].classList.contains("active")) {
      navItems[i].classList.remove("active");
    }
  }
  navItems[imenu].classList.add("active");
};

export const resetNavSubMenu = (main_idx, sub_idx) => {
  let navBlock = document.querySelector(".nav");
  let navItems = navBlock.querySelectorAll(".depth2 > li");
  //console.log(navItems)
  for (var i = 0; i < navItems.length; i++) {
    if (navItems[i].classList.contains("active")) {
      navItems[i].classList.remove("active");
    }
  }
  if (sub_idx < 0) {
    return;
  }
  const depth1Boxes = document.querySelectorAll(".depth1");
  const depth2Boxes = depth1Boxes[main_idx].querySelector(".depth2");
  const liBoxes = depth2Boxes.querySelectorAll("li");
  //   console.log(liBoxes)
  if (!liBoxes[sub_idx].classList.contains("active")) {
    liBoxes[sub_idx].classList.add("active");
  }
};

//화면조정
export const mobileWrap = () => {
  if (window.innerWidth < 890) {
    let tr = $(".tr");
    if (!tr.children().hasClass("m_wrap")) {
      tr.wrapInner("<div className='m_wrap'>");
      for (var i = 0; i < tr.length; i++) {
        let mWrap = $(tr[i]).children(".m_wrap");
        mWrap.after($(mWrap).children(".row_btn"));
      }
    }
  } else {
    let mWrap = $(".m_wrap");
    mWrap.children().unwrap();
  }
};

export const mobileWrapSearchTalent = () => {
  if (window.innerWidth < 1024) {
    let tr = document.querySelectorAll(".tr");
    if (!$(tr).children().hasClass("m_colgroup")) {
      for (var i = 0; i < tr.length; i++) {
        $(tr[i])
          .find(".m_group")
          .wrapAll("<div className='m_colgroup group1'></div>");
        $(tr[i])
          .find(".row_sort")
          .wrapAll("<div className='m_colgroup group2'></div>");
      }
    }
  } else {
    $(".m_colgroup").children().unwrap();
  }
};

export const addDateDBFormat = (sdate, adddays) => {
  let fdate = new Date();
  if (sdate !== null && sdate !== "" && sdate !== "null") {
    fdate = new Date(sdate);
  }
  if (adddays === 0) return sdate;
  fdate.setDate(fdate.getDate() + adddays);
  return ChangeDateFormat(fdate);
};

//문자열에 공백이 있는 경우
export function blank_pattern(asValue) {
  let blankStr = /[\s]/g;
  if (blankStr.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 특수문자가 있는 경우
export function special_pattern(asValue) {
  let specialStr = /[`~!@#$%^&*|\\\'\";:\/?]/gi; //eslint-disable-line
  if (specialStr.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 한글, 영문만 입력 가능
export function name_pattern(asValue) {
  let nameRegExp = /^[가-힣a-zA-Z]+$/;
  if (nameRegExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//문자열에 숫자가 있는 경우
export function include_num(asValue) {
  let numRegExp = /^[0-9]+$/;
  if (numRegExp.test(asValue)) {
    return false;
  } else {
    return true;
  }
}

//이메일중복검사 버튼 표시 결정
export const CheckDuplicationObject = (objID, bmode) => {
  //중복확인버튼 표시 유무
  const objBotton = document.getElementById(objID);
  console.log(objBotton);
  console.log(bmode);
  if (!bmode) {
    if (objBotton.classList.contains("hide"))
      objBotton.classList.remove("hide");
  } else {
    if (!objBotton.classList.contains("hide")) objBotton.classList.add("hide");
  }
};
//파일 input을 리셋
export const resetFileForm = (elFileForm) => {
  var orgParent = elFileForm.parentNode;
  var orgNext = elFileForm.nextSibling;

  var tmp = document.createElement("form");
  tmp.appendChild(elFileForm);

  tmp.reset();
  orgParent.insertBefore(elFileForm, orgNext);
};

//문자열 변환 —— 데이타베이스 저장
export const escapeHtml = (stext) => {
  if (stext === undefined || stext === null || stext === "") return "";
  return stext
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
};
export const unescapeHtml = (stext) => {
  if (stext === undefined || stext === null || stext === "") return "";
  return stext
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/&#039;/g, "'");
};

//파일 크기 제한
export const CheckLimitFileSize = (selFile, kbSize) => {
  const fileSize = selFile.size;
  const maxSize = kbSize * 1024;
  if (fileSize > maxSize) return false;
  else return true;
};

//br 처리
export const changeTextArea = (text) => {
  console.log(typeof text);
  var br_text = "";
  br_text = text.replaceAll(/(\n|\r\n)/g, "<br>");
  // br_text = text?.replace(/&lt;/g, '<');
  // br_text = text?.replace(/&gt;/g,'>');
  // br_text = text?.replace(/&nbsp;/g,' ');
  // br_text = text?.replace(/&amp;/g, '&');
  // br_text = text?.replace(/&quot;/g, '"');
  console.log(br_text);
  return br_text;
};

//문자열에 문자열을 구분자를 통해 추가
export const AddOptionToString = (sadd, stotal, sdiv) => {
  if (stotal === "") {
    stotal = sadd;
  } else {
    stotal = stotal + sdiv + sadd;
  }
  return stotal;
};
//문자열에 구분자로 구분된 문자항목중에서 지정한 문자항목 제외
export const ExceptOptionToString = (soption, stotal, sdiv) => {
  if (!stotal.includes(soption)) return stotal; //옵션이 포함되어 있지 않으면
  if (!stotal.includes(sdiv)) return ""; //구분자없이 지정 옵션만 있으면
  let retString = "";
  const optionArray = stotal.split(sdiv);
  for (var i = 0; i < optionArray.length; i++) {
    if (optionArray[i] !== soption) {
      retString = AddOptionToString(optionArray[i], retString, sdiv);
    }
  }
  return retString;
};

//타이머 - 표시
export const TimeFormat = (itime) => {
  const m = Math.floor(itime / 60).toString();
  let s = (itime % 60).toString();
  if (s.length === 1) s = `0${s}`;
  return `${m}:${s}`;
};

//ALIGO SMS 발송
export const sendMessageToMobile = async (mem_mobile, certCode) => {
  const receiverPhone = ChangeMobileFormat(mem_mobile);
  const message = `요청하신 인증코드입니다 : ${certCode}`;
  const sendData = {
    sender: "1800-9942",
    receiver: receiverPhone,
    msg: message,
    msg_type: "SMS",
  };
  console.log(sendData);
  await axios
    .post(`${process.env.REACT_APP_HOST}/_send_message`, sendData)
    .then((res) => {
      console.log(res.data);
      alert(res.data.message);
    });
};
//NULL 값의 경우 처리 --- 데이타베이스 저장을 위해
export const MakeNullDateFields = function (sfield, sdate) {
  if (sdate === null || sdate === "") {
    return `${sfield}=NULL`;
  } else {
    return `${sfield}='${ChangeSearchingDateFormat(sdate, "-")}'`;
  }
};
//문자열을 배열로 저장
export const MakeStringToArray = function (sString) {
  let namesArray = [];
  if (sString !== null && sString !== "") {
    if (sString.includes(",")) {
      namesArray = sString.split(",");
    } else {
      namesArray[0] = sString;
    }
  }
  return namesArray;
};
//배열을 문자열로 저장
export const MakeArrayToString = function (namesArray) {
  let namesString = "";
  if (namesArray?.length === 0) return namesString;
  if (namesArray?.length === 1) {
    namesString = namesArray[0];
  } else {
    namesString = namesArray.join(",");
  }
  return namesString;
};

//로그인 상태 점검 - 메시지 포함
export const CheckLoginState = () => {
  const loginState = localStorage.getItem("memberLoginState");
  if (
    loginState === undefined ||
    loginState === null ||
    !Boolean(loginState) ||
    Number(loginState) === 0
  ) {
    alert("로그인되지 않은 상태이므로 사용할 수 없습니다. 먼저 로그인 하세요.");
    return false;
  } else {
    return true;
  }
};
export const CheckLoginStateOnly = () => {
  const loginState = localStorage.getItem("memberLoginState");
  if (
    loginState === undefined ||
    loginState === null ||
    !Boolean(loginState) ||
    Number(loginState) === 0
  ) {
    return false;
  } else {
    return true;
  }
};

//FCM TOKEN 메모리에 저장
export const fnGetToken = (token, os) => {
  console.log(token, os);
  localStorage.setItem("fcm_token", token);
};

//페이지 스크롤
export const ScrollHandler = (varPageNum, setPageNum) => {
  const { scrollHeight } = document.documentElement;
  const { scrollTop } = document.documentElement;
  const { clientHeight } = document.documentElement;
  //console.log(scrollTop,scrollHeight,clientHeight);
  //console.log('Scroll',scrollTop,scrollHeight,clientHeight);
  if (
    scrollTop >= scrollHeight - clientHeight &&
    !(scrollTop === 0 && scrollHeight === clientHeight)
  ) {
    setPageNum((varPageNum) => varPageNum + 1);
  }
};

//관리자 체크박스 선택 관련

//체크박스 초기화
export const clearCheckedLists = (bmode) => {
  const checkBoxes = document.querySelectorAll(".del-item");
  for (var i = 0; i < checkBoxes?.length; i++) {
    checkBoxes[i].checked = bmode;
  }
  const checkAllBoxes = document.getElementById("deleteItems");
  checkAllBoxes.checked = bmode;
};
//로그인 상태점검
export const LoginAfterCheckLogin = (imode) => {
  if (imode === 0) {
    const mem_idx = Number(localStorage.getItem("adminIdx"));
    const loginAdmin = localStorage.getItem("adminLoginState");
    if (isNull(loginAdmin) || Number(loginAdmin) === 0 || mem_idx === 0) {
      window.location.href = "/LoginAdmin";
    }
  } else if (imode === 1) {
    const mem_idx = Number(localStorage.getItem("mem_idx"));
    const loginUser = localStorage.getItem("userLoginState");
    if (isNull(loginUser) || Number(loginUser) === 0 || mem_idx === 0) {
      window.location.href = "/Login";
    }
  }
};
export const ShowColorDeliveryStatus = (istatus) => {
  let colors = {
    color: "#FFFFFF",
    backgroundColor: "#8B8B8B",
    borderColor: "#444444",
  };
  switch (istatus) {
    case 1:
      colors = {
        color: "#666666",
        backgroundColor: "#EEEEEE",
        borderColor: "#444444",
      };
      break;
    case 2:
      colors = {
        color: "#FFCB45",
        backgroundColor: "#FFFAEC",
        borderColor: "#FFCB45",
      };
      break;
    case 3:
      colors = {
        color: "#EFEFEF",
        backgroundColor: "#5fa7ea",
        borderColor: "#075fb2",
      };
      break;
    case 4:
      colors = {
        color: "#8B8B8B",
        backgroundColor: "#F3F3F3",
        borderColor: "#8B8B8B",
      };
      break;

    default:
    case 0:
      colors = {
        color: "#FFFFFF",
        backgroundColor: "#8B8B8B",
        borderColor: "#444444",
      };
      break;
  }
  return colors;
};
export const ShowExecuteColorDeliveryStatus = (istatus) => {
  let colors = {
    color: "#FFFFFF",
    backgroundColor: "#8B8B8B",
    borderColor: "#444444",
  };
  switch (istatus) {
    case 1:
      colors = {
        color: "#201E50",
        backgroundColor: "#E9E8ED",
        borderColor: "#201E50",
      };
      break;
    case 2:
      colors = {
        color: "#FFCB45",
        backgroundColor: "#FFFAEC",
        borderColor: "#FFCB45",
      };
      break;
    case 3:
      colors = {
        color: "#CC6969",
        backgroundColor: "#FAF0F0",
        borderColor: "#CC6969",
      };
      break;
    case 4:
      colors = {
        color: "#8B8B8B",
        backgroundColor: "#F3F3F3",
        borderColor: "#8B8B8B",
      };
      break;
    default:
    case 0:
      colors = {
        color: "#FFFFFF",
        backgroundColor: "#8B8B8B",
        borderColor: "#444444",
      };
      break;
  }
  return colors;
};
export const ShowDeliveryStatus = (istatus) => {
  let title = "";
  switch (istatus) {
    case 1:
      title = "운송전";
      break;
    case 2:
      title = "상차완료";
      break;
    case 3:
      title = "하차완료";
      break;
    case 4:
      title = "운송완료";
      break;
    default:
    case 0:
      title = "종료";
      break;
  }
  return title;
};
export const SetDeliveryStatus = (istatus) => {
  let svalue = "";
  switch (istatus) {
    case "운송전":
      svalue = 1;
      break;
    case "상차완료":
      svalue = 2;
      break;
    case "하차완료":
      svalue = 3;
      break;
    case "운송완료":
      svalue = 4;
      break;
    default:
    case "종료":
      svalue = 0;
      break;
  }
  return svalue;
};
export const SetClassDeliveryStatus = (istatus) => {
  let className = "";
  switch (istatus) {
    case 1:
      className = "driving-state-bar wait";
      break;
    case 2:
      className = "driving-state-bar drivining";
      break;
    case 3:
      className = "driving-state-bar offload";
      break;
    case 4:
      className = "driving-state-bar";
      break;
    default:
    case 0:
      className = "driving-state-bar";
      break;
  }
  return className;
};
export const ExecuteDeliveryStatus = (istatus) => {
  let title = "";
  switch (istatus) {
    case 1:
      title = "상차완료";
      break;
    case 2:
      title = "하차완료";
      break;
    case 3:
      title = "운송완료";
      break;
    case 4:
      title = "운송완료";
      break;
    default:
    case 0:
      title = "종료";
      break;
  }
  return title;
};
export const SetCustomerLinesString = (obj) => {
  let stext = obj.csl_riding_name;
  if (!isNull(obj.csl_middle_name)) stext += " - " + obj.csl_middle_name;
  stext +=
    " - " + obj.csl_quit_name + " (" + addThousandPoint(obj.csl_cost) + "원)";
  return stext;
};

//배차
export const ResetDeliveryData = (data) => {
  //객체를 배열로 {상차일:2023.09.02,하차일:2023.09.02,.....} --> [[상차일,2023.09.02],[하차일:2023.09.02],...]
  let dataArray = Object.entries(data);
  console.log(dataArray);
  //배열을 객체로 [{상차일:2023.09.02},{하차일:2023.09.02}...] ---> {dc_dc_riding_date:2023.09.02,...}
  let sendData = {
    dc_mem_idx: localStorage.getItem("adminIdx"),
    cs_idx: 0,
    mem_idx: 0,
  };
  console.log(sendData);
  for (var i = 0; i < dataArray.length; i++) {
    const items = dataArray[i]; //[상차일,2023.09.02]
    let value = items[1];
    let sfstr = "";
    switch (items[0]) {
      case "상차일":
        sfstr = "dc_riding_date";
        value = replaceAll(value, ".", "-");
        break;
      case "하차일":
        sfstr = "dc_quit_date";
        value = replaceAll(value, ".", "-");
        break;
      case "상차지":
        sfstr = "dc_riding_address";
        break;
      case "하차지":
        sfstr = "dc_quit_address";
        break;
      case "거래처코드":
        sfstr = "cs_code";
        break;
      case "거래처명":
        sfstr = "cs_name";
        value = value.trim();
        break;
      case "차량번호":
        sfstr = "dr_carnumb";
        value = value.trim();
        break;
      case "배차기사":
        sfstr = "driver_name";
        value = value.trim();
        break;
      case "운임료(원)":
        sfstr = "dc_price";
        value = removeThousandPoint(value);
        break;
      case "인수증 결제방법":
        sfstr = "dc_receipt_payment";
        value = SetReceiptPayment(value);
        break;
      case "인수증":
        sfstr = "dc_receipt_image";
        value = value === "등록" ? 2 : value === "미등록" ? 0 : -1;
        break;
      case "요청톤":
        sfstr = "dc_prd_req_ton";
        break;
      case "상품":
        sfstr = "dc_prd_name";
        value = value.trim();
        break;
      case "수량":
        sfstr = "dc_prd_quantity";
        value = removeThousandPoint(value);
        break;
      case "운행량(Km)":
        sfstr = "dc_volume";
        value = removeThousandPoint(value);
        break;
      case "수수료율(%)":
        sfstr = "dc_charge";
        break;
      case "실운행가(원)":
        sfstr = "dc_rprice";
        value = removeThousandPoint(value);
        break;
      case "지급원가(원)":
        sfstr = "dc_dprice";
        value = removeThousandPoint(value);
        break;
      case "유의사항":
        sfstr = "dc_prd_notice";
        break;
      case "전자전표":
        sfstr = "dc_prd_slip";
        value = value === "Y" ? 1 : 0;
        break;
      case "기사연락처":
        sfstr = "driver_mobile";
        value = ChangeMobileNumber(value);
        break;
      case "상태":
        sfstr = "dc_status";
        value = SetDeliveryStatus(value);
        break;
      case "실적신고":
        sfstr = "dc_reported";
        value = value === "미신고" ? 0 : 1;
        break;
      default:
        sfstr = "";
        break;
    }
    if (sfstr !== "") {
      sendData[sfstr] = value;
    }
  }
  return sendData;
};
//거래처
export const ResetCustomerData = (data) => {
  let dataArray = Object.entries(data);
  console.log(dataArray);
  let sendData = { cs_mem_idx: localStorage.getItem("adminIdx") };
  console.log(sendData);
  for (var i = 0; i < dataArray.length; i++) {
    const items = dataArray[i]; //[상차일,2023.09.02]
    let value = items[1];
    let sfstr = "";
    switch (items[0]) {
      case "거래처코드":
        sfstr = "cs_code";
        value = value.trim();
        break;
      case "거래처명":
        sfstr = "cs_name";
        value = value.trim();
        break;
      case "업태":
        sfstr = "cs_sectors";
        break;
      case "종목":
        sfstr = "cs_items";
        break;
      case "연락처":
        sfstr = "cs_mobile";
        value = ChangeMobileNumber(value);
        break;
      case "이메일":
        sfstr = "cs_email";
        break;
      case "사업장주소":
        sfstr = "cs_address";
        break;
      case "우편주소":
        sfstr = "cs_post_address";
        break;
      case "등록일자":
        sfstr = "cs_rdate";
        if (typeof value === "string") {
          value = replaceAll(value, ".", "-");
        } else {
          value =
            value.getFullYear() +
            "-" +
            ("0" + (value?.getMonth() + 1)).slice(-2) +
            "-" +
            ("0" + value?.getDate()).slice(-2);
        }
        break;
      default:
        sfstr = "";
        break;
    }
    if (sfstr !== "") {
      sendData[sfstr] = value;
    }
  }
  return sendData;
};
//거래처 노선 정보
export const ResetCustomerLineData = (data) => {
  let dataArray = Object.entries(data);
  //console.log(dataArray);
  let sendData = { cs_idx: 0 };
  for (var i = 0; i < dataArray.length; i++) {
    const items = dataArray[i]; //[상차일,2023.09.02]
    let value = items[1];
    let sfstr = "";
    switch (items[0]) {
      case "거래처명":
        sfstr = "cs_name";
        value = value.trim();
        break;
      case "상차지명":
        sfstr = "csl_riding_name";
        break;
      case "상차지주소":
        sfstr = "csl_riding_address";
        break;
      case "경유지명":
        sfstr = "csl_middle_name";
        break;
      case "경유지주소":
        sfstr = "csl_middle_address";
        break;
      case "하차지명":
        sfstr = "csl_quit_name";
        break;
      case "하차지주소":
        sfstr = "csl_quit_address";
        break;
      case "단가":
        sfstr = "csl_cost";
        value = removeThousandPoint(value);
        break;
      default:
        sfstr = "";
        break;
    }
    if (sfstr !== "") {
      sendData[sfstr] = value;
    }
  }
  return sendData;
};
//드라이버 정보
export const ResetDriverData = (data) => {
  let dataArray = Object.entries(data);
  console.log(dataArray);
  let sendData = {};
  console.log(sendData);
  for (var i = 0; i < dataArray.length; i++) {
    const items = dataArray[i]; //[상차일,2023.09.02]
    let value = items[1];
    let sfstr = "";
    switch (items[0]) {
      case "아이디":
        sfstr = "mem_id";
        break;
      case "비밀번호":
        sfstr = "mem_pwd";
        value = isNaN(value) ? value : value.toString();
        break;
      case "이름":
      case "기사명":
        sfstr = "mem_name";
        break;
      case "차량번호":
        sfstr = "dr_carnumb";
        break;
      case "연락처":
        sfstr = "mem_mobile";
        value = ChangeMobileNumber(value);
        break;
      case "이메일":
        sfstr = "mem_email";
        value = replaceAll(value, ".", "-");
        break;
      default:
        sfstr = "";
        break;
    }
    if (sfstr !== "") {
      sendData[sfstr] = value;
    }
  }
  return sendData;
};

export const ChangeReceiptPayment = (data) => {
  if (isNull(data)) return "";
  const dataArray = data.split(",");
  if (Number(dataArray[0]) === 1) return "없음";
  let retString = "";
  if (Number(dataArray[1]) === 1)
    retString = AddOptionToString("우편", retString, ",");
  if (Number(dataArray[2]) === 1)
    retString = AddOptionToString("사진", retString, ",");
  if (Number(dataArray[3]) === 1)
    retString = AddOptionToString("팩스", retString, ",");
  //console.log(retString);
  return retString;
};
export const SetReceiptPayment = (data) => {
  if (isNull(data)) return "1,0,0,0";
  const dataArray = data.split(",");
  let resetArray = [0, 0, 0, 0];
  for (var i = 0; i < dataArray.length; i++) {
    if (dataArray[i] === "없음") {
      resetArray = [1, 0, 0, 0];
      break;
    } else if (dataArray[i] === "우편") {
      resetArray[1] = 1;
    } else if (dataArray[i] === "사진") {
      resetArray[2] = 1;
    } else if (dataArray[i] === "팩스") {
      resetArray[3] = 1;
    }
  }
  const resetString = resetArray.join(",");
  return resetString;
};
